'use client';

import { useEffect } from "react";

interface ThemeInjectorProps {
  variables: Record<string, string>;
}

export default function ThemeInjector({ variables }: ThemeInjectorProps) {
  useEffect(() => {
    const root = document.documentElement;

    Object.entries(variables).forEach(([key, value]) => {
      root.style.setProperty(key, value);
    });
  }, [variables]);

  return null;
}